export default function PHP_gethostbyname() {
  return (
    <div>
      <h1>PHP_gethostbyname</h1>
    </div>
  );
}
